import React from "react"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import { Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import {
    Checkbox
} from "@material-ui/core"
import { red, blue, teal, purple, orange, green } from '@material-ui/core/colors'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

const stepControlsStructure = {
    sectionComplete: (sectionId, actionCode, step) => console.info(sectionId, actionCode, step),
    markChecklistItem: (event, ChecklistItemsId, ChecklistItem) => console.info(event, ChecklistItemsId, ChecklistItem),
}

const useStyles = makeStyles((theme) => ({
    rootDesktop: { marginTop: theme.spacing(2), marginLeft: theme.spacing(10), marginRight: theme.spacing(10) },
    rootTablet: { marginTop: theme.spacing(2), marginLeft: theme.spacing(5), marginRight: theme.spacing(5) },
    rootMobile: { marginTop: theme.spacing(1), marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    coloredpaper: { color: theme.palette.text.secondary, backgroundColor: "#303030" },
    commentCard: { marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    tableRow: { display: "table-row", paddingTop: 5, paddingBottom: 5, "&:hover": { backgroundColor: theme.palette.background.secondary } },
    closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
}))

const ColoredCheckbox = withStyles({ root: { color: blue[400], '&$checked': { color: green[600] } }, checked: {} })((props) => <Checkbox color="default" {...props} />)

const RSSITicketSteps = ({ ticket, stepControls = stepControlsStructure, classnames = {}, deeplinked = false }) => {
    const classes = useStyles()
    const [selectedSection, setSelectSection] = React.useState(null)

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {ticket.TargetUser.Name !== "UNASSIGNED" ? <TableCell className={classnames.tablecell} variant="head" size="small" align="center" style={{ width: "10px" }} /> : null}
                        <TableCell className={classnames.tablecell} variant="head" size="small" align="center"><Typography variant="h6" color="textSecondary">Step</Typography></TableCell>
                        <TableCell className={classnames.tablecell} variant="head" size="small" align="center" style={{ width: "200px" }}><Typography variant="h6" color="textSecondary">Action</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        ![undefined, null].includes(ticket.Steps) ? (
                            Object.entries(ticket.Steps).map(([sectionId, step]) => (
                                <React.Fragment>
                                    <TableRow key={sectionId}>
                                        {ticket.TargetUser.Name !== "UNASSIGNED" ? <TableCell variant="body" size="small" align="center" style={{ width: "10px" }}><IconButton size="small" onClick={selectedSection === sectionId ? () => setSelectSection(null) : () => setSelectSection(sectionId)}>{selectedSection === sectionId ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</IconButton></TableCell> : null}
                                        <TableCell variant="body" size="small" align="left"><Typography variant="h6" color="textSecondary">{step.SectionName}</Typography></TableCell>
                                        <TableCell variant="body" size="small" align="left" style={{ width: "150px" }}><Button fullWidth variant="contained" color="primary" size="small" disabled={step.SectionCompleted} onClick={() => stepControls.sectionComplete(sectionId, step.ActionCode, step)}><Typography variant="h6" color="textSecondary">{step.SectionCompleted ? `Completed` : `Complete`}</Typography></Button></TableCell>
                                    </TableRow>
                                    {
                                        selectedSection === sectionId ? (
                                            <React.Fragment>
                                                <TableRow key={String(sectionId) + ":detail"}>
                                                    <TableCell variant="body" size="small" align="left"></TableCell>
                                                    <TableCell variant="body" size="small" align="left" colSpan={2}><Typography variant="h6" color="textSecondary">{step.label}</Typography></TableCell>
                                                </TableRow>
                                                {
                                                    step.Checklist ? (
                                                        <TableRow key={String(sectionId) + ":checklist"} classes={{ root: classes.tableRow }}>
                                                            <TableCell colSpan={3} style={{ padding: 0, margin: 0 }}>
                                                                <TableContainer>
                                                                    <Table size="small">
                                                                        <TableBody>
                                                                            {
                                                                                Object.entries(step.ChecklistItems).map(([ChecklistItemsId, ChecklistItem]) => (
                                                                                    <TableRow key={"ChecklistItem:" + String(ChecklistItemsId)}>
                                                                                        <TableCell variant="body" size="small" align="center" style={{ width: "30px" }} />
                                                                                        <TableCell variant="body" size="small" align="center" style={{ width: "10px", padding: 0, margin: 0 }}><ColoredCheckbox checked={ChecklistItem.StepCompleted} onChange={(event) => stepControls.markChecklistItem(event, ChecklistItemsId, ChecklistItem)} /></TableCell>
                                                                                        <TableCell variant="body" size="small" align="left" style={{ paddingLeft: "10px" }}><Typography variant="h6" color="textSecondary">{ChecklistItem.step}</Typography></TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : null
                                                }
                                            </React.Fragment>
                                        ) : null
                                    }
                                </React.Fragment>
                            ))
                        ) : null
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default RSSITicketSteps
